export default __webpack_public_path__ + "a512827f121548426a425fec2b886b53.png";